import { ModalHeader } from "components/components/Modal/commonStyle";
import styled from "styled-components";

export const WizardHeader = styled(ModalHeader)`
  &&& {
    margin-top: 0;
  }
`;
